function capitalize(word: string): string {
  word = word.toLowerCase();
  return word.charAt(0).toUpperCase() + word.slice(1);
}

function capitalizeLabel(label: string, delimiter: string | undefined = undefined): string {
  if (delimiter) {
    return label.split(delimiter).map(word => capitalize(word)).join(delimiter);
  }
  return capitalize(label);
}

export default capitalizeLabel;